var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13118.269 3256.896 606.58 416.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".adots2{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "adots2",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 13595.763, 3405.985)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "adots2",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(13445.471 3457.15) rotate(7)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "adots2",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(13649.253 3527.266) rotate(28)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "adots2",
    cx: 37.401,
    cy: 49.117,
    rx: 37.401,
    ry: 49.117,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 13311.874, 3396.972)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "adots2",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 13301.961, 3576.318)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "adots2",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "translate(13388.693 3271.496) rotate(7)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "adots2",
    cx: 42.809,
    cy: 40.555,
    rx: 42.809,
    ry: 40.555,
    transform: "translate(13248.204 3256.896) rotate(28)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "adots2",
    cx: 33.346,
    cy: 37.852,
    rx: 33.346,
    ry: 37.852,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 13151.455, 3442.935)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots2);
export default __webpack_public_path__ + "static/media/dots2.3df2e3265e32e58bfaea79981feb51b8.svg";
export { ForwardRef as ReactComponent };